/**
 * Generates a CSS variable function string with an optional fallback value.
 *
 * @param {string} customPropName - The name of the CSS custom property (e.g., "--primary-color").
 * @param {string | null} fallBackValue - The fallback value to use if the custom property is not set.
 * @returns {string} The CSS `var()` function string.
 *
 * @example
 * cssVar("--primary-color", "blue"); // "var(--primary-color, blue)"
 * cssVar("--secondary-color", null); // "var(--secondary-color)"
 */
export const cssVar = (customPropName, fallBackValue) => `var(${customPropName}${fallBackValue !== null && fallBackValue !== '' ? ', ' + fallBackValue : ''})`;
